import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios';
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './transactions.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {baseUrl} from '../../config';


import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";


function Transactions() {
    console.log('Transactions')
    const [selectedRow, setSelectedRow] = useState(null);
    const history = useHistory();

    const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
    

checkUserTypeFn(history);

function checkUserTypeFn(history){
  const userdata=JSON.parse(localStorage.getItem('userdata'));
  const usertype=userdata?.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
    history.push('/');
 }

}
    let columnsArray=[];
    const handleSignOut = () => {
        console.log('logout')
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
    
      // if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      //   history.push('/');
      // }
  

    const [cssCodesData,setcssCodesData]=useState([])

    const [resultCount,setResultCount]=useState(0);
    const [resultCountCounter,setResultCountCounter]=useState(0);
    const [loader,setLoader]=useState(false)

    const [message, setMessage] = useState('')
    const [successMsg,setSuccessMsg]=useState('')
    
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    
    useEffect(() => {
        setLoader(true)
        axiosIntance.get(baseUrl+'/count/transactions', {}).then(response => {
          console.log('resultCount='+response.data.result);
          setResultCount(response.data.result);
          setResultCountCounter(1);
          setLoader(false)
        }).catch(error => {
          console.log(error)
          setMessage('Something went wrong');
        });
    
    
        return () => {
          console.log('un subscribe')
        }
    
    
    
      }, [])

      const SubmitDelete = (e) => {

        confirmAlert({
          title: '',
          message: 'Are you sure want to delete All data',
          buttons: [
            {
              label: 'Yes',
              onClick: () => 
              axiosIntance.delete(baseUrl+'/transactions', {}).then(response => {
                setSuccessMsg('Deleted!')
              //  setTimeout(()=>window.location.href = '/viewTransactions',2000)
              }).catch(error => {
                setMessage('Something went wrong');
              })
    
            },
            {
              label: 'No',
              onClick: () => console.log('No')
            }
          ]
        });
      }
    return (
        <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


    <div className='delete-div'>
      {
       resultCount>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All</button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>

    
   
      <section id="content-wrapper">

      
      {loader &&
      <div className='loaderDiv'>  
          <Loader
                type="Circles"
                color="#b4d6fa"
                height={100}
                width={100}
                //timeout={1000} //3 secs
            />
      </div> 
      }

{/* <div className='loaderDiv'>  
          <Loader
                type="Circles"
                color="#b4d6fa"
                height={100}
                width={100}
                //timeout={1000} //3 secs
            />
      </div>  */}
      

      {resultCountCounter>0 && 


      
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}
          columns={
            [
              {title: 'order_id', field: 'order_id'},
              {title: 'created_by', field: 'created_by'},
              {title: 'bill_first', field: 'bill_first'},
              {title: 'bill_last', field: 'bill_last'},
              {title: 'bill_address1', field: 'bill_address1'},
              {title: 'bill_address2', field: 'bill_address2'},
              {title: 'bill_city', field: 'bill_city'},
              {title: 'bill_state', field: 'bill_state'},
              {title: 'bill_zip', field: 'bill_zip'},
              {title: 'bill_country', field: 'bill_country'},
              {title: 'bill_phone', field: 'bill_phone'},
              {title: 'bill_email', field: 'bill_email'},
              {title: 'ship_first', field: 'ship_first'},
              {title: 'ship_last', field: 'ship_last'},
              {title: 'ship_address1', field: 'ship_address1'},
              {title: 'ship_address2', field: 'ship_address2'},
              {title: 'ship_city', field: 'ship_city'},
              {title: 'ship_state', field: 'ship_state'},
              {title: 'ship_zip', field: 'ship_zip'},
              {title: 'ship_country', field: 'ship_country'},
              {title: 'ship_phone', field: 'ship_phone'},
              {title: 'ship_email', field: 'ship_email'},
              {title: 'ship_method_name', field: 'ship_method_name'},
              {title: 'ship_method_description', field: 'ship_method_description'},
              {title: 'ship_group_name', field: 'ship_group_name'},
              {title: 'ship_group_code', field: 'ship_group_code'},
              {title: 'ship_price', field: 'ship_price'},
              {title: 'weight', field: 'weight'},
              {title: 'delivery_confirmation', field: 'delivery_confirmation'},
              {title: 'signature_confirmation', field: 'signature_confirmation'},
              {title: 'non_taxable_total', field: 'non_taxable_total'},
              {title: 'taxable_total', field: 'taxable_total'},
              {title: 'sub_total', field: 'sub_total'},
              {title: 'sales_tax_percent', field: 'sales_tax_percent'},
              {title: 'sales_tax_factor', field: 'sales_tax_factor'},
              {title: 'order_total', field: 'order_total'},
              {title: 'date_of_sale', field: 'date_of_sale'},
              {title: 'time_of_sale', field: 'time_of_sale'},
              {title: 'tracking_number', field: 'tracking_number'},
              {title: 'payment', field: 'payment'},
              {title: 'campaign_id', field: 'campaign_id'},
              {title: 'customer_number', field: 'customer_number'},
              {title: 'prospect_number', field: 'prospect_number'},
              {title: 'document_id', field: 'document_id'},
              {title: 'credit_card_number', field: 'credit_card_number'},
              {title: 'credit_card_expiration', field: 'credit_card_expiration'},
              {title: 'prepaid_match', field: 'prepaid_match'},
              {title: 'gateway_id', field: 'gateway_id'},
              {title: 'gateway_alias', field: 'gateway_alias'},
              {title: 'gateway_processing_percent', field: 'gateway_processing_percent'},
              {title: 'gateway_reserve_percent', field: 'gateway_reserve_percent'},
              {title: 'gateway_transaction_fee', field: 'gateway_transaction_fee'},
              {title: 'gateway_chargeback_fee', field: 'gateway_chargeback_fee'},
              {title: 'gateway_descriptor', field: 'gateway_descriptor'},
              {title: 'gateway_customer_service_number', field: 'gateway_customer_service_number'},
              {title: 'processor_id', field: 'processor_id'},
              {title: 'ip_address', field: 'ip_address'},
              {title: 'ip_address_lookup', field: 'ip_address_lookup'},
              {title: 'order_status', field: 'order_status'},
              {title: 'decline_reason', field: 'decline_reason'},
              {title: 'is_cascaded', field: 'is_cascaded'},
              {title: 'original_gateway_id', field: 'original_gateway_id'},
              {title: 'original_decline_reason', field: 'original_decline_reason'},
              {title: 'shipped_date', field: 'shipped_date'},
              {title: 'is_fraud', field: 'is_fraud'},
              {title: 'fraud_date', field: 'fraud_date'},
              {title: 'is_chargeback', field: 'is_chargeback'},
              {title: 'chargeback_date', field: 'chargeback_date'},
              {title: 'chargeback_by', field: 'chargeback_by'},
              {title: 'is_rma', field: 'is_rma'},
              {title: 'rma_number', field: 'rma_number'},
              {title: 'rma_reason', field: 'rma_reason'},
              {title: 'rma_date', field: 'rma_date'},
              {title: 'rma_created_by', field: 'rma_created_by'},
              {title: 'return', field: 'return_'},
              {title: 'return_reason', field: 'return_reason'},
              {title: 'is_recurring', field: 'is_recurring'},
              {title: 'recurring_date', field: 'recurring_date'},
              {title: 'retry_date', field: 'retry_date'},
              {title: 'total_installments', field: 'total_installments'},
              {title: 'transaction_number', field: 'transaction_number'},
              {title: 'auth_number', field: 'auth_number'},
              {title: 'retrying', field: 'retrying'},
              {title: 'retries_left', field: 'retries_left'},
              {title: 'retry_attempt', field: 'retry_attempt'},
              {title: 'hold_date', field: 'hold_date_v'},
              {title: 'is_void', field: 'is_void'},
              {title: 'void_amount', field: 'void_amount'},
              {title: 'void_date', field: 'void_date'},
              {title: 'voided_by', field: 'voided_by'},
              {title: 'is_refund', field: 'is_refund'},
              {title: 'refund_amount', field: 'refund_amount'},
              {title: 'refund_date', field: 'refund_date'},
              {title: 'refunded_by', field: 'refunded_by'},
              {title: 'afid', field: 'afid'},
              {title: 'sid', field: 'sid'},
              {title: 'affid', field: 'affid'},
              {title: 'c1', field: 'c1'},
              {title: 'c2', field: 'c2'},
              {title: 'c3', field: 'c3'},
              {title: 'bid', field: 'bid'},
              {title: 'aid', field: 'aid'},
              {title: 'opt', field: 'opt'},
              {title: 'rebill_discount', field: 'rebill_discount'},
              {title: 'billing_cycle', field: 'billing_cycle'},
              {title: 'parent_order_id', field: 'parent_order_id'},
              {title: 'product_id', field: 'product_id'},
              {title: 'product_name', field: 'product_name'},
              {title: 'product_attributes', field: 'product_attributes'},
              {title: 'is_product_shippable', field: 'is_product_shippable'},
              {title: 'product_price', field: 'product_price'},
              {title: 'product_sku', field: 'product_sku'},
              {title: 'product_category', field: 'product_category'},
              {title: 'description', field: 'description'},
              {title: 'quantity', field: 'quantity'},
              {title: 'declared_value', field: 'declared_value'},
              {title: 'confirmation', field: 'confirmation'},
              {title: 'confirmation_date', field: 'confirmation_date_v'},
              {title: 'next_recurring_product', field: 'next_recurring_product'},
              {title: 'next_recurring_product_id', field: 'next_recurring_product_id'},
              {title: 'acquisition_date_time', field: 'acquisition_date_time'},
              {title: 'blacklisted', field: 'blacklisted'},
              {title: 'ancestor_order_id', field: 'ancestor_order_id'},
              {title: 'decline_salvage_discount', field: 'decline_salvage_discount'},
              {title: 'decline_salvage_discount_%', field: 'decline_salvage_discount_'},
              {title: 'test', field: 'test'},
              {title: 'is_cancel', field: 'is_cancel'},
              {title: 'hold_type', field: 'hold_type'},
              {title: 'Offer_Id', field: 'offer_id'},
              {title: 'Billing_Model_Id', field: 'billing_model_id'},

              {title: 'upsell_product_id_#1', field: 'upsell_product_id_1'},
              {title: 'upsell_product_name_#1', field: 'upsell_product_name_1'},
              {title: 'upsell_product_attributes_#1', field: 'upsell product_attributes_1'},
              {title: 'is_recurring_upsell_#1', field: 'is_recurring_upsell_1'},
              {title: 'upsell_recurring_date_#1', field: 'upsell_recurring_date_1'},
              {title: 'upsell_retry_date_#1', field: 'upsell_retry_date_1'},
              {title: 'upsell_hold_date_#1', field: 'upsell_hold_date_1'},
              {title: 'upsell_retrying_#1', field: 'upsell_retrying_1'},
              {title: 'is_upsell_shippable_#1', field: 'is_upsell_shippable_1'},
              {title: 'upsell_product_price_#1', field: 'upsell_product_price_1'},
              {title: 'upsell_product_sku_#1', field: 'upsell_product_sku_1'},
              {title: 'upsell_product_category_#1', field: 'upsell_product_category_1'},
              {title: 'upsell_description_#1', field: 'upsell_description_1'},
              {title: 'upsell_declared_value_#1', field: 'upsell_declared_value_1'},
              {title: 'upsell_next_recurring_product_#1', field: 'upsell_next_recurring_product_1'},
              {title: 'upsell_offer_id_1', field: 'upsell_offer_id_1'},
              {title: 'Upsell_Billing_Model_Id_1', field: 'upsell_billing_model_id_1'},
              {title: 'upsell_product_id_#2', field: 'upsell_product_id_2'},
              {title: 'upsell_product_name_#2', field: 'upsell_product_name_2'},
              {title: 'upsell_product_attributes_#2', field: 'upsell_product_attributes_2'},
              {title: 'is_recurring_upsell_#2', field: 'is_recurring_upsell_2'},
              {title: 'upsell_recurring_date_#2', field: 'upsell_recurring_date_2'},
              {title: 'upsell_retry_date_#2', field: 'upsell_retry_date_2'},
              {title: 'upsell_hold_date_#2', field: 'upsell_hold_date_2'},
              {title: 'upsell_retrying_#2', field: 'upsell_retrying_2'},
              {title: 'is_upsell_shippable_#2', field: 'is_upsell_shippable_2'},
              {title: 'upsell_product_price_#2', field: 'upsell_product_price_2'},
              {title: 'upsell_product_sku_#2', field: 'upsell_product_sku_2'},
              {title: 'upsell_product_category_#2', field: 'upsell_product_category_2'},
              {title: 'upsell_description_#2', field: 'upsell_description_2'},
              {title: 'upsell_quantity_#2', field: 'upsell_quantity_2'},
              {title: 'upsell_declared_value_#2', field: 'upsell_declared_value_2'},
              {title: 'upsell_next_recurring_product_#2', field: 'upsell_next_recurring_product_2'},
              {title: 'upsell_next_recurring_product_id_#2', field: 'upsell_next_recurring_product_id_2'},

              {title: 'Upsell_Offer_Id_2', field: 'upsell_offer_id_2'},
              {title: 'Upsell_Billing_Model_Id_2', field: 'upsell_billing_model_id_2'},

              {title: 'notes', field: 'notes'},
              {title: 'customer_tags', field: 'customer_tags'},
              {title: 'is_scheduler', field: 'is_scheduler'},

              
            ]
           
        
        }
          // data={
          //   cssCodesData
          // }
          
          // data={query =>
          //   new Promise((resolve, reject) => {
          //     const selectedRows = this.state.selectedRows;
          //     let url = baseUrl+'/transactions?'
          //     url += 'per_page=' + query.pageSize
          //     url += '&page=' + (query.page + 1)
          //     fetch(url)
          //       .then(response => response.json())
          //       .then(result => {
          //         const selectedData = result.data.map(row => selectedRows.find(selected => selected.id === row.id) ? { ...row, tableData: { checked: true } } : row)
          //         resolve({
          //           data: selectedData,
          //           page: result.page - 1,
          //           totalCount: result.total,
          //         })
          //       })
          //   })
          // } 
          
          
          data={query =>
            new Promise((resolve, reject) => {
              console.log(query)
              setLoader(true)
              let url = baseUrl+'/transactions?'
              url += `&_page=${query.page + 1}`
              url += `&_limit=${query.pageSize}`

              fetchInstance(url)
                .then(response => response.json())
                .then(result => {
                  setLoader(false)
                  resolve({
                    data: result.result,
                    page: query.page,
                    totalCount: resultCount,
                  })
                })
            })
          }
        
          options={{
            sorting: false,
            search: false,
            loadingType: 'overlay',
             pageSize:10,
             pageSizeOptions:[10],
            // rowStyle: {height: 1000},
            // rowStyle: {height: "0px"},
            //  padding: "dense",
            // headerStyle: { fontSize:'15px',fontWeight:'bold' },
            // maxBodyWidth: '100px',
             maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
          
          title="Transactions"
        />



        }
        
        
      </section>
    </div>


    )
}

export default Transactions
